import { lazy, Suspense } from "react";

/**
 * Deliberately tiny and free of CSS imports.
 *
 * The layout registry is imported eagerly by App.jsx, so anything this module
 * pulls in statically would land in the main bundle and ship to every v1
 * visitor — including all of v2's CSS. Keeping the real layout behind a lazy
 * import means v2 costs a gated visitor nothing.
 *
 * The Suspense boundary lives here because App.jsx's only boundary is inside
 * the layout's children, which wouldn't cover a suspending layout.
 */
const V2LayoutInner = lazy(() => import("./V2LayoutInner.jsx"));

export default function V2Layout(props) {
  return (
    <Suspense fallback={null}>
      <V2LayoutInner {...props} />
    </Suspense>
  );
}
